import { useTranslation } from 'react-i18next';
import styles from './ArchiveButton.module.css';
import ListingStatus from '../../../enums/listingStatus'
import ArchiveLineIcon from '../../atoms/icons/ArchiveLineIcon';
import InboxLineIcon from '../../atoms/icons/InboxLineIcon';
import ButtonNew from '../../molecules/button/Button';
import { MouseEvent } from 'react';
import { Tooltip } from '../../atoms/tooltip';

interface ArchiveButtonProps {
    status: ListingStatus | string;
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

const ArchiveButton = ({
    status,
    onClick
}: ArchiveButtonProps) => {
    const { t } = useTranslation();

    const renderIcon = () => {
        switch (status) {
            case ListingStatus.Archived:
            case ListingStatus.Closed:
                return (<InboxLineIcon />);
            case ListingStatus.Open:
                return (<ArchiveLineIcon />);
            default:
                return null;
        }
    }

    const renderTitle = () => {
        switch (status) {
            case ListingStatus.Archived:
            case ListingStatus.Closed:
                return t('actions.unarchive');
            case ListingStatus.Open:
                return t('actions.archive');
            default:
                return '';
        }
    }

    if (status === ListingStatus.Closed) {
        return (
            <Tooltip
                anchor={
                    <ButtonNew
                        iconBefore={renderIcon()}
                        variant='secondary-gray'
                        className={styles.archiveButton}
                        onClick={onClick}
                        disabled
                    >
                        {renderTitle()}
                    </ButtonNew>
                }
                size='lg'
            >
                {t('listings.ads.cannotReopen')}
            </Tooltip>
        );
    }
    
    return (
        <ButtonNew
            iconBefore={renderIcon()}
            variant='secondary-gray'
            className={styles.archiveButton}
            onClick={onClick}
        >
            {renderTitle()}
        </ButtonNew>
    )
}

export default ArchiveButton;
